export const TAB_PARAM = 'tab';

export function isAllowedTab(tabId, allowedTabs) {
  return Boolean(tabId && Array.isArray(allowedTabs) && allowedTabs.includes(tabId));
}

export function readTabFromUrl(allowedTabs, { defaultTab = null } = {}) {
  if (typeof window === 'undefined') {
    return defaultTab;
  }

  const params = new URLSearchParams(window.location.search);
  const tab = params.get(TAB_PARAM);
  if (isAllowedTab(tab, allowedTabs)) {
    return tab;
  }

  return defaultTab;
}

export function writeTabToUrl(tabId, { omitDefault = null } = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);

  if (omitDefault && tabId === omitDefault) {
    url.searchParams.delete(TAB_PARAM);
  } else {
    url.searchParams.set(TAB_PARAM, tabId);
  }

  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
}
